import React from "react";

// Import common mana symbols directly to ensure they are bundled
import w from "../mana-icons/svg/w.svg";
import u from "../mana-icons/svg/u.svg";
import b from "../mana-icons/svg/b.svg";
import r from "../mana-icons/svg/r.svg";
import g from "../mana-icons/svg/g.svg";
import c from "../mana-icons/svg/c.svg"; // Colorless
import tap from "../mana-icons/svg/tap.svg";
import x from "../mana-icons/svg/x.svg";
import y from "../mana-icons/svg/y.svg";
import z from "../mana-icons/svg/z.svg";
import t from "../mana-icons/svg/tap.svg"; // Alias T to tap

// Numbers
import n0 from "../mana-icons/svg/0.svg";
import n1 from "../mana-icons/svg/1.svg";
import n2 from "../mana-icons/svg/2.svg";
import n3 from "../mana-icons/svg/3.svg";
import n4 from "../mana-icons/svg/4.svg";
import n5 from "../mana-icons/svg/5.svg";
import n6 from "../mana-icons/svg/6.svg";
import n7 from "../mana-icons/svg/7.svg";
import n8 from "../mana-icons/svg/8.svg";
import n9 from "../mana-icons/svg/9.svg";
import n10 from "../mana-icons/svg/10.svg";
import n11 from "../mana-icons/svg/11.svg";
import n12 from "../mana-icons/svg/12.svg";
import n13 from "../mana-icons/svg/13.svg";
import n14 from "../mana-icons/svg/14.svg";
import n15 from "../mana-icons/svg/15.svg";
import n16 from "../mana-icons/svg/16.svg";
import n20 from "../mana-icons/svg/20.svg";

const MANA_MAP: Record<string, string> = {
  w, u, b, r, g, c,
  t, tap,
  x, y, z,
  "0": n0, "1": n1, "2": n2, "3": n3, "4": n4,
  "5": n5, "6": n6, "7": n7, "8": n8, "9": n9,
  "10": n10, "11": n11, "12": n12, "13": n13, 
  "14": n14, "15": n15, "16": n16, "20": n20
};

const MANA_COLORS: Record<string, string> = {
  w: "#fdfbce",
  u: "#bcdaf7",
  b: "#a7999e",
  r: "#f19b79",
  g: "#9fcba6",
  c: "#d0c6bb",
};

interface ManaIconProps {
  symbol: string;
  className?: string;
}

export function ManaIcon({ symbol, className }: ManaIconProps) {
  // Normalize: remove braces, lowercase
  const key = symbol.replace(/[{}]/g, "").toLowerCase();
  const iconSrc = MANA_MAP[key];
  const bgColor = MANA_COLORS[key] || "#d0c6bb"; // Default to colorless/gray

  if (!iconSrc) {
    // If not found, return text wrapped in braces
    return <span className="font-mono text-sm font-bold mx-0.5" title={`Mana: ${symbol}`}>{symbol}</span>;
  }

  return (
    <img 
      src={iconSrc} 
      alt={symbol} 
      className={`inline-block w-5 h-5 p-0.5 rounded-full mx-0.5 align-middle shadow-sm ${className || ""}`}
      style={{ backgroundColor: bgColor }}
      title={`Mana: ${symbol}`}
    />
  );
}
